<footer class="footer">
	<div class="container-fluid">
		<div class="row">
			<div class="col-12 col-md footer-left">
			Copyright &copy; 2019.  <a href="http://www.sifytechnologies.com/" target="_blank">Sify Technologies Limited</a>. All rights reserved.
			</div>
			<div class="col-12 col-md footer-right">
				<a href="#">Privacy Policy</a> | <a href="#">Disclaimer</a> | <a href="#">Term of use</a>
			</div>
		</div>    
	</div>
</footer>